module.exports = __webpack_public_path__ + "assets/landscape.e74976b6.svg";